module.exports = __webpack_public_path__ + "static/media/thumb-down-svgrepo-com (2).80198408.svg";